export const HOST_URL = window.location.hostname;
export const API_BASE_URL = window.API_BASE_URL ? window.API_BASE_URL : window.location.hostname.includes("localhost") ? "http://localhost:3020/api/v1" : 'https://' + window.location.hostname + '/api/v1';

export const BASE_URL = window.API_BASE_URL ? window.API_BASE_URL : window.location.hostname.includes("localhost") ? "http://localhost:3020/" : 'https://' + window.location.hostname + '/';
